import { fork, takeEvery } from "redux-saga/effects";

import PaymentConstants from "modules/payment/constants";
import PaymentSagas from "modules/payment/sagas";

function* watchGetRemainingBudgetList() {
  yield takeEvery(PaymentConstants.GET_REMAIN_BUDGET_LIST, PaymentSagas.GetRemainingBudgetList);
}

function* watchGetAVGUsage() {
  yield takeEvery(PaymentConstants.GET_AVG_USAGE, PaymentSagas.GetAVGUsage);
}

function* watchGetPaymentHistory() {
  yield takeEvery(PaymentConstants.PAYMENT_HISTORY, PaymentSagas.GetPaymentHistory);
}

export default [fork(watchGetRemainingBudgetList), fork(watchGetAVGUsage), fork(watchGetPaymentHistory)];
